<template lang="pug">
    div(:style="'min-height:'+h")
        div.px-0.white.detail-head.head-border
            el-row.pl-5
                el-col(:span="8")
                    Breadcrumb(:data="items")
                el-col.pt-5.text-right(:span="15")
                    el-button(type="primary" size="mini" :loading="loading" @click="preserve(1)") 保存
                    el-button(type="primary" size="mini" :loading="loading" @click="preserve(2)") 保存并发布
                    el-button(v-show="type==2" type="danger" size="mini" :loading="loading" @click="del") 删除
                    el-button(type="primary" size="mini" @click="$router.go(-1)") 返回
        div(style="height:70px")
        el-main.white.pa-3.ma-4
            el-row
                el-col(:span="20")
                    div 基本信息
            el-form.mt-4(:model="head" ref="head" label-width="100px" size="mini" :rules="rules")
                el-row
                    el-col(:span="7")
                        el-form-item(label="采购组织:" prop="pk_org")
                            el-select.w-100(size="mini" v-model="head.pk_org" :filter-method="sourcebuyorg" filterable placeholder="采购组织" @change="changeOrg" :disabled="head.pk_org?true:false")
                                el-option(v-for="item in buyorg" :key="item.pk_org" :label="item.name" :value="item.pk_org")
                    el-col(:span="7")
                        el-form-item(label="采购员:" prop="buy_person")
                            el-select.w-100(size="mini" v-model="item" :loading="loadingPerson" value-key="pk_psndoc" @change="changePerson" filterable remote placeholder="请选择人员" :remote-method="getQuery" )
                                el-option(v-for="item in person" :key="item.pk_psndoc" :label="item.name+'-'+item.name_org" :value="item")
                    el-col(:span="7")
                        el-form-item(label="联系方式:")
                            span {{head.buy_person_mobile}}
                el-row
                    el-col(:span="7")
                        el-form-item(label="供应商:" prop="sys_supplier_code")
                            span {{head.supplier_name}}
                    el-col(:span="7")
                        el-form-item(label="联系人:")
                            span {{head.contact}}
                    el-col(:span="7")
                        el-form-item(label="联系方式:")
                            span {{head.contact_phone}}

                el-row
                    el-col(:span="7")
                        el-form-item(label="对账日期:" prop="begin_date")
                            el-date-picker.w-100(v-model="time" disabled="true" type="daterange" align="right" unlink-panels range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions1" @change="changeTime")
                    el-col(:span="7")
                        el-form-item(label="对账月份" prop="remark")
                            el-input.w-100(v-model="head.remark")
                    <!--el-col(:span="7")-->
                    <!--el-form-item(label="对账合同:" prop="id_ct")-->
                    <!--el-select.w-100(size="mini" v-model="head.id_ct" filterable placeholder="合同" @change="changeCt")-->
                    <!--el-option(v-for="item in cts" :key="item.id" :label="item.name" :value="item.id")-->
                el-row
                    el-col(:span="21")
                        el-form-item(label="备注" prop="note")
                            el-input(v-model="head.note" placeholder="请输入")
            el-row.mt-5.mb-2
                el-col(:span="20")
                    div 对账单总表
                el-col(:span="4")
                    el-button(type="primary" size="mini" @click="getMonthPayment" :loading="loading") 获取数据
            el-table(:data="[head]" style="width: 100%"  size="mini")
                el-table-column(prop="classification" label="对账类别" width="200")
                    template(slot-scope="scope")
                        el-form.mt-4(:model="scope.row" ref="head1" :rules="rules" size="mini")
                            el-form-item(prop="classification")
                                el-input(style="width:170px" v-model="scope.row.classification")
                                div.fr.red--text *
                el-table-column(prop="before_debt" label="期初欠款")
                    template(slot-scope="scope")
                        el-input-number.w-100(size="mini" v-model="scope.row.before_debt" controls-position="right"  :precision="2"  :disabled="true")
                el-table-column(prop="before_invoice" label="期初欠票" width="120" key="before_invoice")
                <!--el-table-column(prop="current_num" label="本期采购数量" width="120" key="current_num")-->
                el-table-column(prop="current_money" label="本期采购金额" width="120" key="current_money")
                el-table-column(prop="current_invoice" label="本期到票金额" width="120" key="current_invoice")
                el-table-column(prop="current_pay" label="本期付款")
                    template(slot-scope="scope")
                        el-input-number.w-100(size="mini" v-model="scope.row.current_pay" controls-position="right"  :precision="2" :disabled="true")
                el-table-column(prop="after_debt" label="期末欠款")
                    template(slot-scope="scope")
                        el-input-number.w-100(size="mini" v-model="scope.row.after_debt" controls-position="right"  :precision="2" :disabled="true")
                el-table-column(prop="after_no_invoice" label="期末未到发票")
                    template(slot-scope="scope")
                        el-input-number.w-100(size="mini" v-model="scope.row.after_no_invoice" controls-position="right" :precision="2" :disabled="true")
</template>
<script>
    export default {
        data() {
            return {
                h: "",
                classify: [],
                syncSapSupplyBalance: false,

                head: {
                    synchronize_status: 0,
                    id_ct: null,
                    sys_supplier_code: null,
                    supplier_name:"",
                    pk_supplier:"",
                    pk_org: null,
                    begin_date: null,
                    end_date: null,
                    remark: null,
                    contact: null,
                    contact_phone: null,
                    buy_person:"",
                    buy_person_mobile: null,
                    classification: "货款",
                    before_debt: null,
                    before_invoice: null,
                    current_num: null,
                    current_money: null,
                    current_invoice: null,
                    current_pay: null,
                    after_debt: null,
                    after_no_invoice: null,
                    source: 1,
                    note:'',
                },
                loading: false,
                items: [
                    {
                        path: "/purchase/purchase_order",
                        meta: {
                            title: "月度对账单",
                        },
                    },
                    {
                        path: this.$route.path,
                        meta: {
                            title: "详情",
                        },
                    },
                ],
                loadingSupply: false,
                supply: [],
                time: [],
                rules: {
                    pk_org: [
                        {required: true, message: "请选择采购组织", trigger: "change"},
                    ],
                    remark: [
                        {required: true, message: "请填写对账月份", trigger: "blur"},
                    ],
                    buy_person: [
                        { required: true, message: "请选择采购员", trigger: "change" },
                    ],
                    begin_date: [
                        {required: true, message: "请选择时间", trigger: "change"},
                    ],
                    classification: [
                        {required: true, message: "请填写对账类别", trigger: "blur"},
                    ]
                },
                count: 0,
                cts: [],
                loadingPerson: false,
                person: [],
                list: {
                    code_ct: null,
                    key_name: null,
                    pk_org: null,
                    pk_supplier: this.$store.state.user.supplier.pk_supplier,
                    begin_date: null,
                    end_date: null,
                    page_num: 1,
                    page_size: 10,
                    source_stock_org: null,
                },
                list1: {
                    key_name: null,
                    page_num: 1,
                    page_size: 9999,
                    pk_org: null,
                    begin_date: null,
                    end_date: null,
                },
                item: {
                    pk_psndoc: null,
                    phone: null,
                }
            };
        },
        props: {
            id: {
                type: String,
                default: null,
            },
            type: {
                type: [Number, String],
                default: 1,
            },
        },
        methods: {
            async getMonthPayment() {
                this.$refs["head"].validate(async (valid) => {
                    if (valid) {
                        this.loading = true;
                        let data = {
                            start_time: this.$utils.getTimeByYMD(
                                this.head.begin_date,
                                "YYYYMMDD"
                            ),
                            end_time: this.$utils.getTimeByYMD(this.head.end_date, "YYYYMMDD"),
                            org_code: "",
                            supplier_code: this.head.pk_supplier,
                            supplier_name:this.head.supplier_name
                        };
                        try {
                            this.purchase_org.forEach((e) => {
                                if (e.pk_org == this.head.pk_org) {
                                    data.org_code = e.code;
                                    throw new Error("Stop");
                                }
                            });
                        } catch (e) {
                            if (e.message != "Stop") throw e;
                        }
                        let res = await this.$api.mon_account_statement.monthPayment(data);
                        this.loading = false;
                        if (res) {
                            this.syncSapSupplyBalance = true;
                            this.head.before_debt = res.data.begin_debt;
                            this.head.before_invoice = res.data.before_invoice;
                            this.head.current_num = res.data.current_num;
                            this.head.current_money = res.data.current_money;
                            this.head.current_invoice = res.data.current_invoice;
                            this.head.current_pay = res.data.pay_money;
                            this.head.after_no_invoice = res.data.unpaid_money;
                            this.head.after_debt = res.data.final_money;
                        }
                    }
                });
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            changeTime() {
                if (this.time) {
                    this.head.begin_date = this.time[0];
                    this.head.end_date = this.time[1];
                } else {
                    this.head.begin_date = null;
                    this.head.end_date = null;
                }
            },
            getQuery(query) {
                if (!query) {
                    return false;
                }
                this.list1.key_name = query;
                this.getPersonList();
            },
            changeOrg(e) {
                this.list1.pk_org = e;
                this.getPersonList();
                this.head.buy_person = null;
                this.head.buy_person_mobile = null;
                this.item = null;
                this.list.pk_org = e;
                this.list.key_name = "";
                this.list.page_num = 1;
                this.list.page_size = 10;
            },
            changePerson(e) {
                this.head.buy_person = e.pk_psndoc;
                this.head.buy_person_mobile = e.phone;
            },
            async getPersonList() {
                this.loadingPerson = true;
                let res = await this.$api.global.personList(this.list1);
                this.loadingPerson = false;
                if (res) {
                    this.person = res.data;
                }
            },
            del() {
                this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(async () => {
                        this.loading = true;
                        let res = await this.$api.mon_account_statement.del(this.id);
                        this.loading = true;
                        if (res) {
                            this.$notify({
                                message: "操作成功",
                                type: "success",
                            });
                            this.$router.go(-1);
                        }
                    })
                    .catch(() => {
                    });
            },
            async preserve(type) {
                let flag = false;
                if (!this.syncSapSupplyBalance && this.type == 1) {
                    this.$notify({
                        message: "请先获取供应商余额信息",
                        type: "error",
                    });
                    return;
                }
                this.$refs["head1"].validate((valid) => {
                    if (valid) flag = true;
                });
                this.$refs["head"].validate(async (valid) => {
                    if (valid && flag) {
                        this.loading = true;
                        let res = null;
                        if (type == 2) {
                            this.head.synchronize_status = 1;
                        }
                        if (this.type == 1) {
                            res = await this.$api.mon_account_statement.suppler_add(this.head);
                        } else {
                            res = await this.$api.mon_account_statement.suppler_edit(this.head);
                        }
                        this.loading = false;
                        if (res) {
                            this.$notify({
                                message: "操作成功",
                                type: "success",
                            });
                            this.$router.go(-1);
                        }
                    }
                });
            },
            async getSupplyList(query) {
                if (!query) {
                    return false;
                }
                this.loadingSupply = true;
                let res = await this.$api.supplier.getotherList({
                    key_name: query,
                    page_num: 1,
                    page_size: 100,
                    no_check: 1,
                    checkstatus: 3,
                });
                this.loadingSupply = false;
                if (res) {
                    this.supply = res.data;
                }
            },
            async getById() {
                let res = await this.$api.mon_account_statement.getById(this.id);
                if (res) {
                    this.head = res.data;
                    this.item.pk_psndoc = this.head.buy_person;
                    this.item.phone = this.head.buy_person_mobile;
                    this.list1.pk_org = this.head.pk_org;
                    this.getPersonList();
                    this.list.pk_org = this.head.pk_org;
                    this.time = [this.head.begin_date, this.head.end_date];
                    this.getSupplyList(this.head.supplier_name);
                }
            },
            async getCt() {
                let res = await this.$api.purchase_contract.getCt(
                    this.head.sys_supplier_code,
                    this.head.pk_org
                );
                if (res) {
                    this.cts = res.data;
                }
            }
        },
        mounted() {
            this.h = document.body.clientHeight - 61 + "px";
        },

        created() {
            let user = this.$store.state.user;
            if(user!=undefined && user.role==7){
                this.head.pk_supplier = user.supplier.pk_supplier;
                this.head.sys_supplier_code = user.supplier.code;
                this.head.supplier_name = user.supplier.name;
                this.head.contact = user.supplier.contact;
                this.head.contact_phone = user.supplier.contact_phone;
            }
            if (this.$store.state.token && this.$store.state.purchase_org == false)
                this.getPurchaseOrg();
            if (this.$store.state.token && this.$store.state.stock_org == false)
                this.getStockOrg();
            if (this.type == 1) {
                this.time = this.$utils.lastMonDate();
                this.head.begin_date = this.time[0];
                this.head.end_date = this.time[1];
                this.head.remark = this.$utils.getLastMon(-1,'YYYY-MM');
                this.items[1].meta.title = "新增";
            } else {
                this.getById();
                this.items[1].meta.title = "修改";
            }

        },
        watch: {
            // "head.sys_supplier_code"() {
            //     if (this.head.pk_org) {
            //         this.getCt();
            //     }
            // },
            // "head.pk_org"() {
            //     if (this.head.sys_supplier_code) {
            //         this.getCt();
            //     }
            // },
        }
    };
</script>
<style>
    .el-table .success-row {
        background: #ddebfd;
    }
</style>
